module.exports = __webpack_public_path__ + "img/chart-pie.024459fe.svg";